import { render, staticRenderFns } from "./DevicesSideviewFaultsTab.vue?vue&type=template&id=8bcc1d2a&scoped=true&class=fill-height"
import script from "./DevicesSideviewFaultsTab.vue?vue&type=script&lang=ts"
export * from "./DevicesSideviewFaultsTab.vue?vue&type=script&lang=ts"
import style0 from "./DevicesSideviewFaultsTab.vue?vue&type=style&index=0&id=8bcc1d2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcc1d2a",
  null
  
)

export default component.exports